var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",class:[
    'wrapper',
    ..._vm.wrapperSize,
    _vm.boxed ? 'wrapper--boxed' : false,
    !_vm.margin ? 'wrapper--no-margin' : false,
  ]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }